import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import RailsPropsReducer from './RailsPropsReducer';
import offersReducer from './Offers';
import userDataReducer from './UserData';
import offersDetailsReducer from './OffersDetails';
import betsFormValidationReducer from './BetsFormValidation';
import betsTablesReducer from './BetsTables';
import tableReducer from './Table';
import inRealizationReducer from './InRealization';
import archiveReducer from './ArchiveTables';
import invoicesReducer from './Invoices';
import conversationsReducer from './Conversations';
import channelsReducer from './Channels';
import channelActivationsReducer from './ChannelActivations';
import designReducer from './Design';
import loaderReducer from './Loader';
import modal from './Modal';
import layout from './Layout';
import adsReducer from './Ads';
import promotionsReducer from './Promotions';
import authReducer from './authReducer';
import vehicleTypeReducer from './VehicleTypeReducer';

export default combineReducers({
  form: formReducer,
  railsProps: RailsPropsReducer,
  offers: offersReducer,
  userData: userDataReducer,
  offerDetails: offersDetailsReducer,
  betsFormValidation: betsFormValidationReducer,
  bets: betsTablesReducer,
  inRealization: inRealizationReducer,
  tables: tableReducer,
  archive: archiveReducer,
  invoices: invoicesReducer,
  conversations: conversationsReducer,
  channels: channelsReducer,
  channelActivations: channelActivationsReducer,
  design: designReducer,
  loader: loaderReducer,
  ads: adsReducer,
  promotions: promotionsReducer,
  vehicleType: vehicleTypeReducer,
  modal,
  layout,
  authReducer,
});
